export default __webpack_public_path__ + "b73532c846bc7d5b997cd122e7433f98.png";